module.exports = __webpack_public_path__ + "img/2024120501.affe670d.png";